import { h } from 'hyperapp'
import s from './Game.module.css'
import { REGION_ASSETS } from './regions'
import Dialog from './Dialog'
import Menu from './Menu'
import Digit from './Digit'
import Play from './Play'
import Cell from './Cell'

const Game = ({ key, state, actions }) => (
  <Dialog key={key} title="TrumpSweeper.com">
    <Menu state={state} actions={actions} />
    <div class={s.root}>
      <div class={s.scoreboard}>
        <Digit value={state.game.flags} />
        <Play
          pressed={state.game.pressed}
          lose={state.game.lose}
          win={state.game.win}
          onReset={actions.reset}
        />
        <Digit value={state.game.time} />
      </div>
      <div class={s.fieldWrap}>
        <div
          class={s.field}
          style={{
            '--region-bg': `url(${REGION_ASSETS[state.region] || REGION_ASSETS.hormuz})`,
          }}
          onmouseleave={() => actions.hover({ x: -1, y: -1 })}
        >
          {state.game.field.map((row, y) => (
            <div class={state.game.win || state.game.lose ? s.inactive : s.active}>
              {row.map((cell, x) => (
                <Cell
                  x={x}
                  y={y}
                  pressed={state.game.pressed}
                  pressedX={state.game.pressedX}
                  pressedY={state.game.pressedY}
                  group={state.game.group}
                  opened={cell.opened}
                  mined={cell.mined}
                  flag={cell.flag}
                  mark={cell.mark}
                  num={cell.num}
                  lose={state.game.lose}
                  onDown={actions.down}
                  onMove={actions.move}
                  onHover={actions.hover}
                  onTouch={actions.touch}
                />
              ))}
            </div>
          ))}
        </div>
        {state.game.lose && (
          <div class={s.loseOverlay}>
            <div class={s.loseStack}>
              <p class={s.gameOverText} role="status">
                GAME OVER
              </p>
              <img class={s.loseImage} src="/trump_sad.png" alt="" />
              <p class={s.restartHint}>Press F2 to restart</p>
            </div>
          </div>
        )}
        {state.game.win && (
          <div class={s.winOverlay}>
            <div class={s.winStack}>
              <p class={s.youWinText} role="status">
                YOU WIN!
              </p>
              <img class={s.winImage} src="/trump_win.png" alt="" />
              <p class={s.restartHint}>Press F2 to restart</p>
            </div>
          </div>
        )}
      </div>
    </div>
  </Dialog>
)

export default Game
